// extracted by css-extract-rspack-plugin
export default {"button_red_override":"q_UQR","buttonRedOverride":"q_UQR","#":"Bl809","button_green_override":"C7jOp","buttonGreenOverride":"C7jOp"};